<div
  class="parent-container"
  [dtWidthTrigger]="{ 'sidenav-over': 740 }"
  (dtWidthTriggerStateChange)="changeSidenavOver($event['sidenav-over'])"
>
  <dt-userarea [sidenavEnabled]="sidenavEnabled" (hamburgerButtonClick)="toggleSidenav()"></dt-userarea>
  <div class="column-wrapper" #columnWrapper>
    <div class="main-content">
      <mat-sidenav-container>
        @if (sidenavEnabled) {
          <mat-sidenav
            [mode]="sidenavOver ? 'over' : 'side'"
            [opened]="!sidenavOver || isSidenavExpanded"
            (closed)="isSidenavExpanded = false"
            [disableClose]="!sidenavOver"
            [class.folded]="sidenavFolded"
            [@.disabled]="disableSidenavAnimation"
          >
            <dt-navigation
              [isSidenavOver]="sidenavOver"
              [isUnfolded]="isSidenavExpanded"
              (unfoldButtonClick)="toggleSidenav()"
            ></dt-navigation>
          </mat-sidenav>
        }
        <mat-sidenav-content>
          <div class="content-container" #scrollContainer>
            <div
              class="page-container"
              [class.educational]="decisionData.isEducational()"
              [class.dt-professional]="decisionData.isProfessional()"
              [class.starter]="decisionData.isStarter()"
            >
              <div [class.dt-limit-width]="(isRouterChildMaxWidth$ | async) === false && !decisionData.isStarter()">
                <router-outlet (activate)="routerActivateHandler($event)"></router-outlet>
              </div>
            </div>
          </div>
          @if (navLine) {
            <dt-navline [navLine]="navLine"> </dt-navline>
          }
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>

    @if (sideBySideService.isOpen) {
      <div class="side-by-side" #sideBySideContent [@.disabled]="!sbsAnimationEnabled || sidenavOver" @sbsEnterExit>
        <div
          class="side-by-side-divider"
          [class.dragging]="sbsDragging"
          (mousedown)="sbsMouseDown($event)"
          (touchstart)="sbsTouchStart($event)"
          (touchmove)="sbsTouchMove($event)"
          (touchend)="sbsResizeEnd()"
          (touchcancel)="sbsResizeEnd()"
        >
          <mat-icon>drag_indicator</mat-icon>
        </div>
        <div class="side-by-side-content" [style.width.px]="sbsWidth">
          @switch (sideBySideService.state) {
            @case ('help') {
              <dt-help></dt-help>
            }
            @case ('history') {
              <dt-project-history></dt-project-history>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
